
import {
	deviationSearchRequest,
} from '../requests';

async function fetchDeviations({ commit, state: { searchFilter } }) {
	commit('setValue', { value: true, key: 'deviationsLoading' });
	try {
		let deviations = await deviationSearchRequest(searchFilter);
		commit('setDeviations', deviations);
	} catch (err) {
		throw new Error('failedToFetch');
	} finally {
		commit('setValue', { value: false, key: 'deviationsLoading' });
	}
}

function setDateFrom({ commit }, date) {
	commit('updateSearchFilterDate', { key: 'date', isFrom: true, date });
}
function setDateTo({ commit }, date) {
	commit('updateSearchFilterDate', { key: 'date', isFrom: false, date });
}

function setDeviationNumber({ state }, deviationNumber) {
	state.searchFilter.deviationNumber = deviationNumber;
}

function setClerk({ state }, clerk) {
	state.searchFilter.clerk = clerk;
}

function setStatus({ state }, status) {
	state.searchFilter.status = status;
}

function setDeviationType({ state }, deviationType) {
	state.searchFilter.deviationType = deviationType;
}

function setDeviationCause({ state }, deviationCause) {
	state.searchFilter.deviationCause = deviationCause;
}

function setActionType({ state }, actionType) {
	state.searchFilter.actionType = actionType;
}

function setTerminal({ state }, terminal) {
	state.searchFilter.terminal = terminal;
}

function addGoodsType({ state }, goodsType) {
	let alreadyAdded = state.searchFilter.goodsTypes.some(x => x.id === goodsType.id);
	if (alreadyAdded) return;
	state.searchFilter.goodsTypes.push(goodsType);
}
function setGoodsTypes({ state }, goodsTypes) {
	state.searchFilter.goodsTypes = goodsTypes;
}

function setVendors({ state }, vendors) {
	state.searchFilter.vendors = vendors;
}

function setCustomers({ state }, customers) {
	state.searchFilter.customers = customers;
}

function setCustomerFault({ state }, customerFault) {
	state.searchFilter.customerFault = customerFault;
}

export default {
	fetchDeviations,
	setDateFrom,
	setDateTo,
	setDeviationNumber,
	setClerk,
	setStatus,
	setDeviationType,
	setDeviationCause,
	setActionType,
	setTerminal,
	addGoodsType,
	setGoodsTypes,
	setVendors,
	setCustomers,
	setCustomerFault,
};
